import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col max-w-[150px] transition-opacity" }
const _hoisted_2 = { class: "title-terra font-medium text-lg leading-7 font-serif" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "title-terra"
}
const _hoisted_6 = { class: "text-sm text-merinos-600 leading-5 font-medium" }
const _hoisted_7 = { class: "flex gap-x-4 items-center" }
const _hoisted_8 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = { class: "inline-block font-medium leading-6 text-merinos-800 w-6 text-center" }


export default {
  __name: 'Traveler',
  props: {
  label: String,
  description: String,
  name: String,
  modelValue: Number,
  post: {
    type: Object,
    default: null,
  },
  trad: {
    type: Object,
    required: true,
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {


const emit = __emit

const props = __props

const DEFAULT_MAX = {
  adult: 4,
  child: 4,
  babies: 2,
  dog: 2,
}

const MAX = props.post?.post?.[props.name]

function decrement() {
  if (props.modelValue <= 0) {
    return;
  }

  emit('update:modelValue', props.modelValue - 1)
}

function increment() {
  if (props.post && (props.modelValue >= props.post?.post?.[props.name])) {
    return;
  } else if (props.modelValue >= (DEFAULT_MAX[props.name] || 4)) {
    return;
  }

  emit('update:modelValue', props.modelValue + 1)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex justify-between gap-x-7 items-center py-4", {
      'opacity-50 cursor-not-allowed': __props.post && _unref(MAX) === 0
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(_toDisplayString(__props.label) + " ", 1 /* TEXT */),
        (__props.post && _unref(MAX) !== 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_unref(MAX)) + " " + _toDisplayString(__props.trad.remote_max) + ".)", 1 /* TEXT */))
          : (!__props.post && _unref(MAX) !== 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(DEFAULT_MAX[__props.name] || 4) + " " + _toDisplayString(__props.trad.remote_max) + ".)", 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
      ]),
      (__props.name === 'dog' && __props.post && _unref(MAX) === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "(" + _toDisplayString(__props.trad.remote_not_allowed) + ")", 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("p", _hoisted_6, _toDisplayString(__props.description), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        onClick: decrement,
        "aria-label": "Enlever"
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_8, [
          _createElementVNode("circle", {
            cx: "20",
            cy: "20",
            r: "19.5",
            class: _normalizeClass({
            'stroke-merinos-100': __props.modelValue <= 0,
            'stroke-[#DBC2B5]': __props.modelValue >= 0,
          })
          }, null, 2 /* CLASS */),
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              d: "M13.6792 21.207V19.707H27.1792V21.207H13.6792Z",
              class: _normalizeClass({
              'fill-merinos-200': __props.modelValue <= 0,
              'fill-terra-900': __props.modelValue > 0,
            })
            }, null, 2 /* CLASS */)
          ])
        ]))
      ]),
      _createElementVNode("span", _hoisted_9, _toDisplayString(__props.modelValue), 1 /* TEXT */),
      _createElementVNode("button", {
        onClick: increment,
        "aria-label": "Ajouter"
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          width: "40",
          height: "40",
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("circle", {
            cx: "20",
            cy: "20",
            r: "19.5",
            stroke: "#DBC2B5",
            "stroke-opacity": "0.3"
          }),
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              d: "M19.6792 27.207V21.207H13.6792V19.707H19.6792V13.707H21.1792V19.707H27.1792V21.207H21.1792V27.207H19.6792Z",
              fill: "#A45944"
            })
          ])
        ], -1 /* HOISTED */)
      ]))
    ])
  ], 2 /* CLASS */))
}
}

}